export default __webpack_public_path__ + "static/media/feature-network-1.c67cf285.png";